import React, { useEffect, useState } from 'react';
import { deleteRequest, getRequests, newPassword } from '../../api/forgotPassword';
import LoadingPage from '../Loading/loading';
import { FiSearch } from 'react-icons/fi';

const ForgotPasswordPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [id, setId] = useState('');
    const [idDelete, setIdDelete] = useState('');
    const [forgotPassword, setForgotPassword] = useState(null);
    const [forgotPasswordFinal, setForgotPasswordFinal] = useState(null);

    useEffect(() => {
        setForgotPassword(null)
        getRequests().then((result) => {
            setForgotPassword(result.data.response)
            setForgotPasswordFinal(result.data.response)
        })
    }, [])

    const requestDelete = (id) => {
        deleteRequest(id).then((result) => {
            setForgotPasswordFinal(forgotPasswordFinal.filter(forgotPasswordFinalUser => forgotPasswordFinalUser._id !== id));
        })
    };

    const requestNewPassword = (id) => {
        newPassword(id).then((result) => {
            setId("")
            setForgotPassword(forgotPassword.map(user =>
                user._id === id ? { ...user, done: true, password: result.data.new_password } : user
            ));
            navigator.clipboard.writeText(result.data.new_password)
                .then(() => alert('New password is copied to clipboard!'))
                .catch(err => console.error('Failed to copy:', err));
        })
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (value) {
            setForgotPasswordFinal(forgotPassword.filter(user =>
                user.name.toLowerCase().includes(value.toLowerCase()) ||
                user.phone.toLowerCase().includes(value.toLowerCase())
            ));
        } else {
            setForgotPasswordFinal(forgotPassword);
        }
    };

    return (
        <>{forgotPasswordFinal === null ? (<LoadingPage />) : (<div>
            <div className="card-cards">
                {forgotPasswordFinal?.length === 0 ? <div>Not found</div> : <>{forgotPasswordFinal?.map(user => (
                    <div key={user._id} className={`card-card`}>
                        <div className="card-info">
                            <div>
                                <p className='line'><span className="label">Name:</span> {user.name}</p>
                                <p className='line'><span className="label">Phone:</span> {user.phone}</p>
                                <p className='line'><span className="label">WhatsApp:</span> {user.whatsApp}</p>
                                <p className="line">
                                    <span className="label">Admin Code:</span>{" "}
                                    {user?.admin_code}
                                </p>
                                <p className='line'><span className="label">Date:</span> {user.createdAt.split("T")[0]}</p>
                                {(id === user._id) && < div style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "5px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <p className='line'>Are you sure you want to reset password of this user? </p>
                                    <div className="card-info">
                                        <div className="card-actions">
                                            <button
                                                onClick={() => { setId("") }}
                                                className="action-btn remove-btn"
                                            >
                                                No
                                            </button>
                                        </div>
                                        <div className="card-actions">
                                            <button
                                                onClick={() => { requestNewPassword(user._id) }}
                                                className="action-btn accept-btn"
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>}
                                {(idDelete === user._id) && < div style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "5px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <p className='line'>Are you sure you want to delete this request? </p>
                                    <div className="card-info">
                                        <div className="card-actions">
                                            <button
                                                onClick={() => { setIdDelete("") }}
                                                className="action-btn remove-btn"
                                            >
                                                No
                                            </button>
                                        </div>
                                        <div className="card-actions">
                                            <button
                                                onClick={() => { requestDelete(user._id) }}
                                                className="action-btn accept-btn"
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                        {(id !== user._id && idDelete !== user._id) && <div className="card-actions">
                            <button
                                onClick={() => { setIdDelete(user._id) }}
                                className="action-btn remove-btn"
                            >
                                Delete request
                            </button>
                            {user.done ? <button
                                onClick={() => {
                                    navigator.clipboard.writeText(user.password)
                                        .then(() => alert('New password is copied to clipboard!'))
                                        .catch(err => console.error('Failed to copy:', err));
                                }}
                                className="action-btn accept-btn"
                            >
                                {user.password}
                            </button> : <button
                                onClick={() => { setId(user._id) }}
                                className="action-btn accept-btn"
                            >
                                Reset password
                            </button>}
                        </div>}
                    </div>
                ))}</>}
            </div>
        </div>)}</>
    );
};

export default ForgotPasswordPage;